import { useState } from 'react';
import { telemetry } from '../lib/telemetry.ts';
import { useT } from '../i18n/index.tsx';

/**
 * Step 6: the three 1–10 scales the acceptance criteria are scored on.
 * Numbers only — they ride the same telemetry channel as everything else, and
 * that channel has no room for free text by design.
 */
const SCALES = ['accuracy', 'voice', 'comfort'] as const;

export function Rating() {
  const t = useT();
  const [scores, setScores] = useState<Record<string, number>>({});
  const [sent, setSent] = useState(false);

  if (sent) {
    return <p className="lede">{t.rating.thanks}</p>;
  }

  return (
    <div>
      {SCALES.map((key) => (
        <div className="field" key={key}>
          <label htmlFor={key}>
            {t.rating[key]}: <strong>{scores[key] ?? '—'}</strong>
          </label>
          <input
            id={key}
            type="range"
            min={1}
            max={10}
            step={1}
            value={scores[key] ?? 5}
            onChange={(e) => setScores((s) => ({ ...s, [key]: Number(e.target.value) }))}
            style={{ width: '100%' }}
          />
        </div>
      ))}
      <button
        type="button"
        className="primary"
        disabled={Object.keys(scores).length === 0}
        onClick={() => {
          telemetry.record('rating', scores);
          void telemetry.flush();
          setSent(true);
        }}
      >
        {t.rating.send}
      </button>
    </div>
  );
}
